import { Routes } from '@angular/router';
import { slugGuard } from 'src/app/common/slug/slug.guard';

export const WONDER_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./content.component').then(c => c.ContentComponent),
    canActivate: [slugGuard],
    data: { contentType: 'wonder' },
  },
  {
    path: ':slug',
    loadComponent: () => import('./content.component').then(c => c.ContentComponent),
    canActivate: [slugGuard],
    data: { contentType: 'wonder' },
  },
];
